import {Row, Col, Form} from 'react-bootstrap'
import {TFormSignature} from '../../signatureFormsTypes'
import {FormikErrors, FormikTouched} from 'formik'
import React from 'react'
import {RichTextEditor} from '../../../shared/RichTextEditor'
import {
  clientVarsByLead,
  clientVarsByPolicy,
  infoAgenteVars,
  infoPolicyVars,
} from '../../signatureFormsConst'

interface SignatureFormNotificationsProps {
  values: TFormSignature
  errors: FormikErrors<TFormSignature>
  touched: FormikTouched<TFormSignature>
  handleChange: (field: string, value: string) => void
  handleBlur: (field: string) => void
}

export const SignatureFormNotifications: React.FC<SignatureFormNotificationsProps> = ({
  values,
  errors,
  handleChange,
  handleBlur,
}) => {
  return (
    <div className='form-notifications'>
      <Row>
        <Col sm={12}>
          <div className='kt-heading kt-heading--md custom-border-brand'>
            Signature Form Notifications
          </div>
        </Col>
      </Row>

      <Row>
        <Col md={12} className='email-content'>
          <Form.Group>
            <Form.Label>
              Email Content{' '}
              {errors.emailContent && <small className='text-danger'>{errors.emailContent}</small>}
            </Form.Label>
            <RichTextEditor
              value={values.emailContent}
              placeholder='Enter content email'
              onChange={(e) => handleChange('emailContent', e)}
              btnCustomPicker={[
                clientVarsByLead,
                clientVarsByPolicy,
                infoPolicyVars,
                infoAgenteVars,
              ]}
            />
          </Form.Group>
        </Col>
        <Col md={12} className='sms-content'>
          <Form.Group>
            <Form.Label>
              SMS Content{' '}
              {errors.smsContent && <small className='text-danger'>{errors.smsContent}</small>}
            </Form.Label>
            <Form.Control
              value={values.smsContent}
              onChange={(e) => handleChange('smsContent', e.target.value)}
              onBlur={() => handleBlur('smsContent')}
              required
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  )
}

/* <ReactQuill
              theme='snow'
              placeholder='Type here...'
              value={values.emailContent}
              className='h-100 h-full-quill'
              onChange={(e) => handleChange('emailContent', e)}
              style={{minHeight: '120px'}}
              modules={{
                toolbar: [
                  ['bold', 'italic', 'underline', 'strike'],
                  ['blockquote', 'code-block'],
                  ['link', 'formula'],

                  [{list: 'ordered'}, {list: 'bullet'}, {list: 'check'}],
                  [{indent: '-1'}, {indent: '+1'}], // outdent/indent

                  [{header: [1, 2, 3, 4, 5, 6, false]}],

                  [{color: []}, {background: []}], // dropdown with defaults from theme
                  [{font: []}],
                  [{align: []}],

                  ['clean'], // remove formatting button
                ],
              }}
            /> */
